<div class="page-padding">
  <!--component setup panel-->
  <div class="panel">
    <div class="panel__header">
      <!--Main header-->
      <span class="panel__header__title">{{Translate('Fleet Component Forecast')}}</span>
    </div>

    <mat-card class="panel_search mat-card">
      <!--sub header-->
      <div class="panel_sub_header">
        <span class="panel__header__title">{{Translate('Setup Equipment')}}</span>
      </div>

      <!--form-->
      <form class="header-form">
        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{Translate('Dealer Name')}}" (selectionChange)="changeDealer($event.value)" name="dealerID"
            [(ngModel)]="dealerID">
            <mat-option value="0"> </mat-option>
            <mat-option [value]="type.DealershipId" *ngFor="let type of dealerList">
              {{type.DealershipName}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{Translate('Make')}}" name="makeid" [(ngModel)]="makeid">
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.Id" *ngFor="let type of _componentService.availableMakeList">
              {{type.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <input matInput [matDatepicker]="startDatePicker" placeholder="{{Translate('Start Date')}}" [(ngModel)]="startDate"
            [ngModelOptions]="{standalone: true}">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{Translate('Customer')}}" name="cusID" [(ngModel)]="cusID" (selectionChange)="changeCustomer($event.value)">
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.customerId" *ngFor="let type of customerList">
              {{type.customerName}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{Translate('Family')}}"  name="typeid" [(ngModel)]="typeid">
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.Id" *ngFor="let type of _fleetService.familyList">
              {{type.Title + ' | ' + type.Symbol}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <input matInput [matDatepicker]="endDatePicker" placeholder="{{Translate('End Date')}}" [(ngModel)]="enddate" 
            [ngModelOptions]="{standalone: true}">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker ></mat-datepicker>
        </mat-form-field>


        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{Translate('Jobsite')}}" name="jobsiteID" [(ngModel)]="jobsiteID" (selectionChange)="changeJobsite($event.value)">
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.crsf_auto" *ngFor="let type of jobsiteList">
              {{type.site_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{Translate('Model')}}" name="modelID_" [(ngModel)]="modelID">
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.Id" *ngFor="let type of _componentService.availableModelList">
              {{type.Title}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select [(ngModel)]="interval" name="interval" placeholder="{{Translate('Interval')}}">
            <mat-option value="1">Monthly</mat-option>
            <mat-option value="2">Quarterly</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{Translate('Serial No./ Unit No.')}}" name="serialno" [(ngModel)]="equipmentid_auto">
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.EquipmentId" *ngFor="let type of equipmnentList">
             {{ type.SerialNo + '| '+ type.UnitNo}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{Translate('Component')}}" name="comptypeID_" [(ngModel)]="comptypeID">
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.Id" *ngFor="let type of _componentService.componentTypeList">
              {{type.Title}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-radio-group class="header-form-full-width" [(ngModel)]="rdTotal_Details" name="rdTotal_Details">
          <mat-radio-button [value]="1">{{Translate('Totals Only')}}</mat-radio-button>
          <mat-radio-button [value]="2">{{Translate('Totals & Details')}}</mat-radio-button>
        </mat-radio-group>

        <!-- <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{Translate('Unit No.')}}" name="unitino" [(ngModel)]="unitino">
              <mat-option value="0"> </mat-option>
            <mat-option [value]="type.EquipmentId" *ngFor="let type of equipmnentList">
              {{type.UnitNo}}
            </mat-option>
          </mat-select>
        </mat-form-field> -->

        <div class="bottom-row">

          <a class="button"><span class="button__text"  (click)="resetFields()">{{Translate('Reset')}}</span></a>
          <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text"
              (click)="loadCompForecastInfo()">{{Translate('Search')}}</span></a>
          <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text"
              (click)="exportAsXLSX()">
              {{Translate('Export to Excel')}}</span></a>

        </div>
      </form>


    </mat-card>
<!--total only table-->
<div *ngIf="newSelection">
<mat-card class="panel_search mat-card" *ngIf="isLoad">
  <!--sub header-->
  <div class="panel_sub_header">
    <span class="panel__header__title">{{Translate('Parts Totals')}}</span>
  </div>
  <!--Table View-->

  <div *ngIf="showTableView" >
    <!--Table-->
      <!--placeholder-->
      <mat-table class="table-material table-material-scroll table-material--striped table-material--hover table-material--full-width" 
      #table [dataSource]="dataSourceTotal" matSort>

       <ng-container matColumnDef="id">
          <mat-header-cell [ngClass]="'customWidthClass'" *matHeaderCellDef mat-sort-header> Component ID </mat-header-cell>
          <mat-cell [ngClass]="'customWidthClass'" *matCellDef="let element"> {{element.id}} </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="comaptyType">
          <mat-header-cell [ngClass]="'customWidthClass'" *matHeaderCellDef mat-sort-header>Component Type</mat-header-cell>
          <mat-cell [ngClass]="'customWidthClass'" *matCellDef="let element"> {{element.comaptyType}} </mat-cell>
        </ng-container>
        <div *ngFor="let items of resultColumHeaders; let i = index">
            <ng-container matColumnDef="{{items}}">
              <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>{{items}}</mat-header-cell>

              <mat-cell *matCellDef="let element" class="no-padding">

                <span class="component-span top  {{getforecastClass(element[items])}}">
                    {{ element[items] == 0 ?"" : element[items] }}
                  </span>
              </mat-cell>

            </ng-container>
          </div>

      <mat-header-row *matHeaderRowDef="displayedColumnsTotal"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsTotal; " [ngClass]="{ 'selected': row === selectedRow }"
        ></mat-row>
    </mat-table>
    <mat-spinner class="loading-spinner mat-progress-spinner" *ngIf="tableDataLoading"></mat-spinner>
  </div>
  

</mat-card>
<!--end total only table-->
    <mat-card class="panel_search mat-card" *ngIf="rdTotal_Details==2">
      <!--sub header-->
      <div class="panel_sub_header">
        <span class="panel__header__title">{{Translate('Equipment Details')}}</span>
      </div>
      <!--Table View-->
      <section class="example-section">
        <mat-checkbox class="example-margin" [(ngModel)]="Customer" (change)="changeCheckbox(Customer, 'Customer',0 )">{{Translate('Customer')}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="Jobsite" (change)="changeCheckbox(Jobsite, 'sitename',1 )">{{Translate('Jobsite')}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="ComponentID" (change)="changeCheckbox(ComponentID, 'compart',7 )">{{Translate('Component')}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="SerialNo" (change)="changeCheckbox(SerialNo, 'serialno',2 )">{{Translate('Serial No.')}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="UnitNo" (change)="changeCheckbox(UnitNo, 'unitino',3 )">{{Translate('Unit No.')}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="Make" (change)="changeCheckbox(Make, 'make',4 )">{{Translate('Make')}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="Family" (change)="changeCheckbox(Family, 'type',5 )">{{Translate('Family')}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="Model" (change)="changeCheckbox(Model, 'model' ,6)">{{Translate('Model')}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="OEMPart" (change)="changeCheckbox(OEMPart, 'OEM' ,7)">{{Translate('OEM Part#')}}</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="MFRPart" (change)="changeCheckbox(MFRPart, 'MFR' ,7)">{{Translate('MFR Part#')}}</mat-checkbox>
      </section>

      <div *ngIf="showTableView">
        <mat-table class="table-material table-material-scroll table-material--striped table-material--hover table-material--full-width" style="height:780px;"
          #table [dataSource]="dataSource" matSort>

          <ng-container matColumnDef="Customer">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> Customer </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Customer}}">
              <div class="SerialAndUnitText"> {{element.Customer}} </div>
            </mat-cell>

          </ng-container>

          <ng-container matColumnDef="sitename">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> JobSite </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element"  matTooltip="{{element.sitename}}"> 
                <div class="SerialAndUnitText">{{element.sitename}} </div> </mat-cell>
          </ng-container>
          <ng-container matColumnDef="unitino">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> Unit no </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.unitino}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="serialno">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> Serial no </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element"  matTooltip="{{element.serialno}}"> 
                <div class="SerialAndUnitText">{{element.serialno}} </div> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="make">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> Make </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.make}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="type">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> Family </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.type}}">
              <div class="SerialAndUnitText"> {{element.type}} </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="model">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> Model </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.model}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="compart">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> ComponentID </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.compart}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="OEM">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> OEM Part# </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.OEMpart}} </mat-cell>
          </ng-container>
         
          <ng-container matColumnDef="MFR">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> MFR Part# </mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.MFRpart}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="comaptyType">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> Type</mat-header-cell>
            <mat-cell class="customWidthClass" *matCellDef="let element"> {{element.comaptyType}} </mat-cell>
          </ng-container>

          <div *ngFor="let items of resultColumHeaders; let i = index">
            <ng-container matColumnDef="{{items}}">
              <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>{{items}}</mat-header-cell>

              <mat-cell *matCellDef="let element" class="no-padding">

                <span class="component-span top  {{getforecastClass(element[items])}}">

                  {{ element[items] == 1 ? element[items] : ""}} </span>
              </mat-cell>

            </ng-container>
          </div>
          <mat-header-row *matHeaderRowDef="displayedColumns; "></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns; " [ngClass]="{ 'selected': row === selectedRow }"
            ></mat-row>
        </mat-table>
        <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
        </mat-paginator>
      </div>


    </mat-card>
    <mat-spinner class="loading-spinner mat-progress-spinner" *ngIf="tableDataLoading"></mat-spinner>
  </div>
  </div>
</div>
